/**
 * PuzzleDashAdapter
 *
 * Puzzle Dash Battle (PDB) shares its entire in-battle UX with Position
 * Trainer Battle: same chessboard widget, same single-line walker, same
 * per-puzzle `<puzzleId>:<uci>:<0|1>` wire shape, same score-history dot
 * row, same useBattlePuzzles hydration. The ONLY differences are the end
 * condition (target-reached vs time-up) and the score-panel chrome — both
 * of which live in BattleScreen + ScorePanel, not in the adapter.
 *
 * So PDB's adapter is a thin re-registration of `PositionTrainerAdapterView`
 * under a different `BattleType` key. No new walker code.
 */

import React from 'react';

import {BattleType} from '../types';
import {registerAdapter, type BattleAdapter} from '../registry';
import {
  PositionTrainerAdapterView,
  type PositionTrainerAdapterProps,
} from './PositionTrainerAdapter';

const adapter: BattleAdapter = {
  battleType: BattleType.PUZZLE_DASH,
  renderGame: (props: PositionTrainerAdapterProps) => (
    <PositionTrainerAdapterView {...props} />
  ),
};

registerAdapter(adapter);

export default adapter;
